<template>
  <div class="banner card">
    <div class="icon">🤝</div>
    <div class="content">
      <h3>Bem-vindo, {{ nome }}!</h3>
      <p>
        Voce ainda nao esta vinculado a nenhum evento.
        Pede pro administrador da plataforma te vincular ao(s) evento(s) que voce vai coordenar.
      </p>
      <p class="small">
        Quando voce for vinculado, vai conseguir ver os inscritos, o saldo a receber e o historico de repasses do seu evento aqui mesmo.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemEventoBanner',
  props: { nome: { type: String, default: '' } }
}
</script>

<style scoped>
.banner {
  display: flex; gap: var(--spacing-base);
  padding: var(--spacing-lg);
  align-items: flex-start;
  background: #ede9fe;
  border-left: 4px solid #6d28d9;
}
.icon { font-size: 32px; line-height: 1; }
.content { flex: 1; display: flex; flex-direction: column; gap: var(--spacing-sm); }
h3 { color: #4c1d95; margin: 0; }
p { color: #5b21b6; margin: 0; line-height: 1.5; }
.small { font-size: var(--text-sm); opacity: 0.85; }
</style>
